
import { mapState } from 'vuex';
import List from '@/components/blocks/list.vue';

export default {
  name: 'Intermission',

  components: {
    List,
  },

  computed: {
    ...mapState(['options']),

    intermissionData() {
      return this.options.blocks.find((b) => b.acf_fc_layout === 'list');
    },
  },
};
